import { createGetEndpoint } from '@sonar-software/sonar-http';
import { Initiative } from '@types';

export type GetInitiativeByIdRequest = {
	id: number;
};

export type GetInitiativeByIdResponse = Initiative;

export const getInitiativeById = createGetEndpoint<GetInitiativeByIdRequest, GetInitiativeByIdResponse>(
	({ id }) => `/api/v3/initiatives/${id}`
);
